import { Service } from '@tino-frontend/adapters'
import { SignInUser } from '@types'

export class UserManagementService {
  constructor(private readonly http: Service) {}

  async createUser(payload: SignInUser) {
    return this.http.post('/users', payload)
  }
}
